import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { useDataAttributes } from '@lumapps/data-attributes';
import { Menu } from '@lumapps/lumx-menu/components/Menu';
import { Text } from '@lumapps/lumx/react';
import { REACTION_TYPES, ReactionType } from '@lumapps/reactions-core/api/types';

import { CLASSNAME } from '../../constants';

export interface MultiReactionRadioGroupProps {
    userReaction?: ReactionType;
    onReactionChange: (reaction: ReactionType) => void;
}

/**
 * Display multi-reaction radio-group
 * */
export const MultiReactionRadioGroup: React.FC<MultiReactionRadioGroupProps> = ({ userReaction, onReactionChange }) => {
    const { get } = useDataAttributes(CLASSNAME);
    const { element } = useClassnames(CLASSNAME);

    return (
        <Menu.SectionRadioGroup
            className={element('radio-group')}
            value={userReaction}
            onChange={onReactionChange as (value: string) => void}
        >
            {REACTION_TYPES.map((type) => (
                <Menu.ItemRadio
                    key={type}
                    className={element('reaction-btn')}
                    value={type}
                    truncate={false}
                    // Reaction size is calculated based on the button height.
                    // Remove all horizontal padding that might mess with the emoji rendering and crop it.
                    style={{ padding: 0 }}
                    {...get({ element: 'react', action: type === userReaction ? 'remove' : 'add', type })}
                >
                    <Text as="span" color="dark" className={element('reaction')}>
                        {type}
                    </Text>
                </Menu.ItemRadio>
            ))}
        </Menu.SectionRadioGroup>
    );
};
